<ng-container *transloco="let t">
  @if (getUsers200Response$ | async; as getUsers200Response) {
    <core-table
      (createButtonEvent)="openCreateModal()"
      (toggleSelectAllEvent)="toggleSelectAll()"
      [columns]="tableColumns"
      [hasCreateButton]="tableHasCreateButton"
    >
      @for (user of getUsers200Response.data; track user) {
        <tr>
          <th>
            <label>
              <input class="checkbox" type="checkbox" />
            </label>
          </th>
          <td>
            <div class="flex items-center gap-3">
              <core-avatar [user]="user" circleClasses="w-12" />
              <div>
                <div class="text-sm opacity-50">{{ user.firstName }}</div>
                <div class="font-bold">{{ user.lastName }}</div>
              </div>
            </div>
          </td>
          <td>
            {{ user.email }}
            <br />
          </td>
          <td>{{ user.createdAt | localeDate: 'medium' }}</td>
          <td>
            <input
              type="checkbox"
              [(ngModel)]="user.isActive"
              (click)="
                toggleUserActiveOrInactive(user, $event);
                $event.stopPropagation()
              "
              class="toggle toggle-primary mx-2"
              [title]="
                user.isActive
                  ? t('user-management-deactivate-button')
                  : t('user-management-activate-button')
              "
            />
            <button (click)="openEditModal(user)" class="btn btn-accent btn-xs">
              {{ t('user-management-details-button') }}
            </button>
            <button
              (click)="deleteUser(user)"
              class="btn btn-circle btn-neutral btn-sm float-right"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </td>
        </tr>
      }
    </core-table>
    <div class="flex items-center justify-center p-4">
      @if (getUsersRequestParams$ | async; as getUsersRequestParams) {
        <div class="flex space-x-1">
          <button
            (click)="changePage(getUsersRequestParams.page! - 1)"
            [disabled]="getUsersRequestParams.page! <= 1"
            class="btn btn-outline"
          >
            {{ t('user-management-previous-button') }}
          </button>
          <div class="join">
            @for (
              page of getPages(getUsers200Response.meta.totalPages);
              track page
            ) {
              <button
                (click)="changePage(page)"
                [class.btn-active]="page === getUsersRequestParams.page"
                class="btn btn-outline join-item"
              >
                {{ page }}
              </button>
            }
          </div>
          <button
            (click)="changePage(getUsersRequestParams.page! + 1)"
            [disabled]="
              getUsersRequestParams.page! >= getUsers200Response.meta.totalPages
            "
            class="btn btn-outline"
          >
            {{ t('user-management-next-button') }}
          </button>
        </div>
      }
    </div>
  }
</ng-container>
